import styles from './index.module.scss'
import PictureZoom from '../../PictureZoom'
import { useRef, useMemo } from 'react'
import Iconfont from '@utils/Iconfont';
import API from '@api/api'
import PSAIModal from '@PSAIComponents/PSAIModal'
import { message } from 'antd'
import { DISPLAY_TYPE, BATCH_IMAGES_TYPE } from '@utils/CONST'

const PicModalMiddle = (props) => {
    const { item, selectedInputImg, currentViewIsHD, rawTasks, displayType } = props
    // const image = currentViewIsHD ? item?.results?.[0]?.hdImage : item?.results?.[0]?.image
    const image = useMemo(() => {
        return currentViewIsHD ? item?.results?.[0]?.hdImage : item?.results?.[0]?.image
    }, [currentViewIsHD, item])

    const disabledHD = useMemo(() => {
        return item?.results?.[0]?.hdStatus == 'started' ||
            item?.results?.[0]?.hdStatus == 'pending' ||
            item?.results?.[0]?.hdStatus == 'processing'
    }, [item])

    const videoRef = useRef()
    const handelVideoPlay = async (play) => {
        try {
            if (play) await videoRef.current.play()
            else await videoRef.current.pause()
        } catch (err) {
            console.error(err)
        }
    }


    const isLoading = useRef(false)
    const toBookmark = (e) => {
        e.stopPropagation()
        if (isLoading.current) return
        isLoading.current = true
        API.bookmarkTask({
            taskId: item?.taskId.split('_')[0]
        }).then(() => {
            props.fetchProjectDetail()
        }).finally(() => {
            isLoading.current = false
        })
    }

    const deleteClick = (e) => {
        e.stopPropagation()
        PSAIModal.confirm({
            centered: true,
            // title: item.imageType == 'tryonVideo' ? "删除视频" : "删除图片",
            // content: `请确认是否删除此${item.imageType == 'tryonVideo' ? "视频" : "结果图"}`,
            title: rawTasks?.length == 1 ? "删除该结果及项目" : "删除该结果",
            content: rawTasks?.length == 1 ? "请确认是否删除该结果及项目？" : "请确认是否删除该结果？",
            icon: null,
            onOk: hadnleDeleteTask
        })
    }
    const hadnleDeleteTask = () => {
        return API.deleteTaskImage({
            taskId: item?.taskId.split('_')[0],
            imageId: item?.results?.[0]?.id
        }).then((res) => {
            if (res?.code === 0) {
                if (displayType == DISPLAY_TYPE.GENERATE && rawTasks?.length == 1) {
                    props.setProjectId('')
                }
                props.fetchProjectDetail()
                message.success('删除成功');
            } else {
                message.error('删除失败');
            }
        })
    };


    return (
        <div className={styles.PicModalMiddle}>
            {
                item?.projectType != BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH && (
                    <div className={styles.zoomBox}>
                        {
                            selectedInputImg && <PictureZoom
                                key={selectedInputImg}
                                imageUrl={selectedInputImg}
                            />
                        }
                        <span className={styles.title}>源素材</span>
                    </div>
                )
            }
            <div className={styles.zoomBox} style={{ width: item?.projectType == BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH ? '100%' : '50%' }}>
                {
                    (image && (image.endsWith('.mp4') || image.endsWith('.MP4'))) ? <div
                        className={styles.videoBox}
                    >
                        <video
                            ref={videoRef}
                            src={image}
                            autoPlay
                            muted
                            loop
                            playsInline
                            disablePictureInPicture
                        />
                        <i className={styles.VideoIcon}></i>
                        <span className={styles.title}>
                            {currentViewIsHD &&
                                <Iconfont
                                    type="icon-hasHDOutlined"
                                    style={{ color: '#FFCF69', fontSize: 20, marginRight: 5 }}
                                />}结果视频
                        </span>
                        {
                            disabledHD && <span className={styles.previewHD}><Iconfont type="icon-loadingOutlined" className={styles.Icon} /> 高清预览中</span>
                        }
                    </div> : <>
                        {
                            image && <PictureZoom
                                key={image}
                                imageUrl={image}
                            />
                        }
                        <span className={styles.title}>
                            {currentViewIsHD &&
                                <Iconfont
                                    type="icon-hasHDOutlined"
                                    style={{ color: '#FFCF69', fontSize: 20, marginRight: 5 }}
                                />}结果图
                        </span>
                    </>
                }

            </div>
        </div>
    )
}

export default PicModalMiddle